import * as THREE from 'three';

import Project from  "../Project"; 

export default class RayCaster {
	constructor() {
        this.project = new Project();
        this.scene = this.project.scene;
        this.world = this.project.world;

        this.mouse = new THREE.Vector2();
        this.raycaster = new THREE.Raycaster();
        this.init();
    }
    init()
    {
        if( this.project.isTouchDevice)
        {
            document.addEventListener( "touchend", ( event ) => {
                this.mouse.x = (event.changedTouches[0].clientX / window.innerWidth ) * 2 - 1;
                this.mouse.y = -(event.changedTouches[0].clientY / window.innerHeight ) * 2 + 1;
                this.checkIntersection();

            } );

        }
        else{
            document.addEventListener( "click", ( event ) => {
                this.mouse.x = (event.clientX / window.innerWidth ) * 2 - 1;
                this.mouse.y = -(event.clientY / window.innerHeight ) * 2 + 1;
                this.checkIntersection();
            } );


        }
        console.log(this.scene);
        
    }
    checkIntersection()
    {
        
        if (this.project.hasPlaced && this.project.CanSelect)
        {
            this.project.uiSoundEffect(this.project.Sploosh_audio);

            this.raycaster.setFromCamera(this.mouse, this.project.camera);

            const intersects = this.raycaster.intersectObjects( this.scene.children[0].children[4].children, false );
            
            if (intersects.length > 0)
            {
                console.log(intersects);
                if (this.intersectMesh != intersects[0].object)
                {
                    this.intersectMesh = intersects[0].object;
                    this.world.returnedIntersectedObject(this.intersectMesh);

                    //console.log(this.intersectMesh);
                    this.intersectMesh = null;
                }
            }
            else 
            {
                console.log("no collision")
                this.intersectMesh = null;
                //this.intersectMesh = this.project.world.asset3D.model.getObjectByName("PineTree2").children[1];
                //this.world.returnedIntersectedObject(this.intersectMesh);
                
            
            }
            
            
        }
    }

}